/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import logoImage from "../../images/SP-PMTA.png";
import '../../css/header.css';


/**
 * A component for the Port25 logo.
 */
export default class Logo extends Component {
    render() {
        return (
            <div>
                <a href="http://www.port25.com">
                    <img src={logoImage} alt="logo" className='logo'/>
                </a>
            </div>
        );
    }
}
